import { FaFacebookF, FaInstagram } from 'react-icons/fa'

import * as S from './style'

const Footer = () => {
  return (
    <S.Wrapper>
      <S.Container>
        <S.Main>
          <S.BrandBlock className="footer-brand">
            <S.BrandLink to="/" aria-label="Ir para a página inicial">
              <S.Logo src="/images/header-logo.png" alt="RedSterna" />
            </S.BrandLink>
            <S.BrandText>
              Descubra, planeje e compartilhe viagens com uma comunidade de
              viajantes.
            </S.BrandText>
          </S.BrandBlock>

          <S.Section className="footer-policies">
            <S.SectionTitle>Políticas</S.SectionTitle>
            <S.InternalLink to="/termos-de-uso">Termos de Uso</S.InternalLink>
            <S.InternalLink to="/politica-de-privacidade">
              Política de Privacidade
            </S.InternalLink>
            <S.InternalLink to="/licenca-de-dados">
              Licença de Dados
            </S.InternalLink>
          </S.Section>

          <S.Section className="footer-about">
            <S.SectionTitle>Sobre nós</S.SectionTitle>
            <S.InternalLink to="/quem-somos">Quem somos</S.InternalLink>
          </S.Section>

          <S.Section className="footer-support">
            <S.SectionTitle>Suporte</S.SectionTitle>
            <S.ExternalLink href="mailto:contato@redsterna.com.br">
              contato@redsterna.com.br
            </S.ExternalLink>
          </S.Section>

          <S.Section className="footer-social">
            <S.SectionTitle>Siga-nos</S.SectionTitle>
            <S.SocialRow>
              <S.SocialLink
                href="https://www.facebook.com/malasprontasviagens"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook da RedSterna"
              >
                <FaFacebookF />
              </S.SocialLink>
              <S.SocialLink
                href="https://www.instagram.com/redsternaoficial/"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram da RedSterna"
              >
                <FaInstagram />
              </S.SocialLink>
            </S.SocialRow>
          </S.Section>
        </S.Main>

        <S.BottomBar>
          <span className="desktop-copy">
            © {new Date().getFullYear()} RedSterna
          </span>
          <span className="desktop-copy">Todos os direitos reservados.</span>
          <span className="mobile-copy">
            © {new Date().getFullYear()} RedSterna · Todos os direitos
            reservados.
          </span>
        </S.BottomBar>
      </S.Container>
    </S.Wrapper>
  )
}

export default Footer
